import { render, staticRenderFns } from "./NewPatientDashboard.vue?vue&type=template&id=b0c7c712&scoped=true&"
import script from "./NewPatientDashboard.vue?vue&type=script&lang=js&"
export * from "./NewPatientDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c7c712",
  null
  
)

export default component.exports